import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { useHRM3110_R01Store } from "./Store_HRM3110_R01";

/**
 * 구분, 과세구분, 사용여부 검색 콤보를 표시한다. 조회는 상위 액션바의 조회 버튼으로 실행한다.
 * @returns 현재 Store 검색 조건이 반영된 검색 영역 JSX
 */
export const HRM3110_R01SearchSection = () => {
    // 화면 Store에서 현재 검색 조건과 변경 함수를 가져온다.
    const { HRM3110_R01Filter, setHRM3110_R01Filter } = useHRM3110_R01Store();
    // 공통코드 Store에서 구분(AD_TYPE)·과세구분(TAX_TYPE)·사용여부(YESNO) 선택 목록을 가져온다.
    const { adTypeList, taxTypeList, yesNoList } = useCommonCodeStore();

    // 공통코드 선택 시 minorCd를 저장하고, 전체 선택 시 빈 문자열을 저장한다.
    return (
        <SearchSectionForm>
            {/* 구분 콤보: 지급(A)을 고르면 공제 그리드가, 공제(D)를 고르면 지급 그리드가 빈 상태로 조회된다. */}
            <SearchDropDownForm
                label="구분"
                value={HRM3110_R01Filter.allowDeductType}
                optionList={adTypeList}
                // ?.: 선택 항목이 없으면(전체) undefined가 되어 ||에 의해 빈 문자열을 저장한다.
                onChangeItem={selectedItem => setHRM3110_R01Filter({ allowDeductType: selectedItem?.minorCd || '' })}
            />
            {/* 과세구분 콤보: 두 그리드에 같은 조건으로 적용된다. */}
            <SearchDropDownForm
                label="과세구분"
                value={HRM3110_R01Filter.taxType}
                optionList={taxTypeList}
                onChangeItem={selectedItem => setHRM3110_R01Filter({ taxType: selectedItem?.minorCd || '' })}
            />
            {/* 사용여부 콤보: 두 그리드에 같은 조건으로 적용된다. */}
            <SearchDropDownForm
                label="사용여부"
                value={HRM3110_R01Filter.useYn}
                optionList={yesNoList}
                onChangeItem={selectedItem => setHRM3110_R01Filter({ useYn: selectedItem?.minorCd || '' })}
            />
        </SearchSectionForm>
    );
};
